import React, { useState } from 'react';
import { Alert, Button } from 'reactstrap';

const EnvironmentWarning = () => {
  const [alert, setAlert] = useState(true);

  if (alert && process.env.CONTENTFUL_ENVIRONMENT !== 'master') {
    return (
      <div className="fixed-bottom m-3" data-cy="environment-warning">
        <Alert
          className="p-3 d-flex justify-content-between"
          fade={false}
          color="warning"
        >
          <p>
            You are viewing the
            {' '}
            <strong>{process.env.CONTENTFUL_ENVIRONMENT}</strong>
            {' '}
            version of this site.
          </p>
          <Button
            onClick={() => setAlert(false)}
            color="secondary"
          >
            Hide
          </Button>
        </Alert>
      </div>
    );
  }

  return null;
};

export default EnvironmentWarning;
